import { useThemeKey } from "@smartsheet/design-tokens-react";
import { useContext } from "react";
import { resolveThemeAlias, LodestarCoreTheme, RequiredThemeKeys } from "../theme";

/**
 * This hook combines the LodestarCoreTheme and the themeKey from the design-tokens-react.
 * The returned themeMode will be a string you can pass to a themed() function.
 */
export const useCombinedThemeMode = (): RequiredThemeKeys => {
    const theme = useContext(LodestarCoreTheme);
    const { themeKey } = useThemeKey();

    return resolveThemeAlias(
        theme === "oldestar"
            ? // If someone has manually set the theme to oldestar, that means they want
              // a legacy UI look.
              theme
            : // Otherwise, we'll let the themed() function's mapper to handle which
              // theme should be used for the given themeKey
              themeKey
    );
};
